// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class InvestmentHistoryView extends JQueryView {
  constructor() {
    super('.managements-container');
  }

  @on({ event: 'show.bs.dropdown', selector: '.dropdown' })
  deleteButtonControl() {
    if ($('.investment-container').find('.dropdown-auto-open').length === 1) {
      $('.js-delete-button').addClass('edit-button-disable');
    }
  }

  @on({ event: 'click' })
  onClickHideDropdownControl(e: any) {
    if (!$(e.target).closest('.dropdown-auto-open').length) {
      // .dropdown-auto-openのエリア以外がクリックされた場合に.dropdownを非表示にする
      $('.js-delete-button').removeClass('edit-button-disable');
    }
  }
}
